import { FC, SubmitEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthentication } from '@connect-x-app/hybrid-state';
import { Role, RolesPermissions } from '@connect-x-app/shared-domain-models';
import { COLORS } from '@connect-x-app/shared-ui';
import { Response } from '@connect-x-app/web-state';
import { Checkbox, Icon, InputField, Tooltip } from '@connect-x-app/web-ui';
import { ReferenceType } from '@floating-ui/react';

import { PageContentBlock, SaveButton } from '../../../../../../shared';

import './roleForm.scss';

type Props = {
  form: Response<Role, Role>;
  onSubmit: (event: SubmitEvent<HTMLFormElement>) => void;
};

export const RoleForm: FC<Props> = ({ form, onSubmit }) => {
  const { t } = useTranslation();
  const [tooltipAnchor, setTooltipAnchor] = useState<ReferenceType | null>(null);

  const { hasPermission } = useAuthentication();

  const canUpdate = hasPermission(RolesPermissions.UPDATE);

  return (
    <>
      <Tooltip alignment="top-start" anchor={tooltipAnchor}>
        <slot name="content">
          <span>{t('USERS.MENTIONABLE.TOOLTIP')}</span>
        </slot>
      </Tooltip>
      <form onSubmit={onSubmit}>
        <div className="role-form-top-container">
          <SaveButton isDisabled={!form.isDirty || !form.isValid} />
        </div>
        <PageContentBlock title={t('ROLESFORM.TITLE.DETAILS')}>
          <div className="row">
            <div className="col-1">
              <InputField
                disabled
                label={t('ROLESFORM.LABEL.NAME')}
                name="airlineRole"
                onChange={form.setAttribute}
                required
                showInlineBottomError
                validation={form.validationErrors.airlineRole}
                value={form.values?.airlineRole || ''}
              />
            </div>
            <div className="col-1">
              <InputField
                disabled={!canUpdate}
                label={t('ROLESFORM.LABEL.DISPLAY_NAME')}
                name="displayName"
                onChange={form.setAttribute}
                required
                showInlineBottomError
                validation={form.validationErrors.displayName}
                value={form.values?.displayName || ''}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-2 role-form-column-taggable">
              <div className={`role-form-checkbox-taggable ${!canUpdate ? 'permission-disabled' : null}`}>
                <Checkbox
                  checked={form.values?.isTaggable}
                  className="set-label-style"
                  disabled={!canUpdate}
                  label={t('ROLESFORM.CHECKBOX.TEXT')}
                  name="airlineRole"
                  onChange={value => form.setAttribute(value, 'isTaggable')}
                />
                <Icon
                  className="ml-1"
                  colorName={COLORS.zulu.$08}
                  name="circularInfoOutline"
                  onHover={anchor => {
                    setTooltipAnchor(anchor.currentTarget);

                    return () => setTooltipAnchor(null);
                  }}
                />
              </div>
            </div>
          </div>
        </PageContentBlock>
      </form>
    </>
  );
};
